import StickySidebar from 'sticky-sidebar-v2';

export const postProgressBar = (progressList) => {
  const postContent = document.querySelector('#postContent');
  var headers = postContent.querySelectorAll('h1, h2, h3');
  var headerPositions = [];

  headers.forEach(function (header, index) {
    var id = 'header-' + index;
    header.id = id;

    var listItem = document.createElement('li');
    listItem.innerHTML = `<span class='selector'></span><span class="label">${header.textContent}</span>`;
    listItem.setAttribute('data-target', id);
    progressList.appendChild(listItem);

    headerPositions.push({ id: id, offset: header.offsetTop });
  });

  window.addEventListener('scroll', function () {
    var scrollPos = document.documentElement.scrollTop || document.body.scrollTop;

    for (var i = 0; i < headerPositions.length; i++) {
      var headerPos = headerPositions[i];

      if (scrollPos >= headerPos.offset - 100) {
        var activeItem = document.querySelector('#progressList li[data-target="' + headerPos.id + '"]');
        if (activeItem) {
          activeItem.classList.add('active');
        }
      } else {
        var activeItem = document.querySelector('#progressList li[data-target="' + headerPos.id + '"]');
        if (activeItem) {
          activeItem.classList.remove('active');
        }
      }
    }
  });

  document.querySelectorAll('#progressList li').forEach(function (li) {
    li.addEventListener('click', function () {
      var targetId = this.getAttribute('data-target');
      var targetElement = document.getElementById(targetId);
      if (targetElement) {
        window.scrollTo({
          top: targetElement.offsetTop - 100,
          behavior: 'smooth'
        });
      }
    });
  });

  const sidebar = new StickySidebar('#sidebarContainer', {
    topSpacing: 150,
    bottomSpacing: 100,
    containerSelector: '#contentWrapper',
    innerWrapperSelector: '#sidebarFixed',
  });

  // if (document.querySelector("#sidebarFixed")) {
  //   const sidebar = document.querySelector("#sidebarFixed");
  //   const container = document.querySelector("#sidebarContainer");
  //   const footer = document.querySelector("#articleFoot");
  //   const top = container.getBoundingClientRect().top - 100;
  //   const footTop = container.getBoundingClientRect().bottom - sidebar.getBoundingClientRect().height;
  //   console.log("🚀 ~ postProgressBar ~ container.getBoundingClientRect().bottom:", container.getBoundingClientRect().bottom)
  //   console.log("🚀 ~ postProgressBar ~ sidebar.getBoundingClientRect().height:", sidebar.getBoundingClientRect().height)
  //   console.log("🚀 ~ postProgressBar ~ bottom - height:", footTop)
  //   console.log("🚀 ~ postProgressBar ~ sidebar.getBoundingClientRect().top:", sidebar.getBoundingClientRect().top)
  //   const maxY = footTop

  //   window.addEventListener("scroll", function () {
  //     let y = document.scrollingElement.scrollTop;
  //     console.log("🚀 ~ y:", y)
  //     console.log("🚀 ~ postProgressBar ~ maxY:", maxY)
  //     if (y > top) {
  //       if (y < maxY) {
  //         sidebar.removeAttribute('style');
  //         sidebar.classList.remove("absolute")
  //         sidebar.classList.add("fixed");
  //         sidebar.style.top = `105px`;
  //       } else {
  //         sidebar.removeAttribute('style');
  //         sidebar.style.bottom = `0`;
  //         sidebar.classList.remove("fixed")
  //         sidebar.classList.add("absolute")
  //       }
  //     } else {
  //       sidebar.classList.remove("fixed")
  //     }
  //   })
  // }
}